import React from 'react';
import PropTypes from "prop-types";
import Select from "react-select";

import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../../../tailwind.config';
const { theme } = resolveConfig(tailwindConfig)


const StatusTabs = ({ tabs, activeTab, onChange, buttonStyles, isDisabled }) => {
    const options = Object.keys(tabs).map(tab => { return { label: tab, value: tab, projectsCount: (tabs[tab] || []).length } })

    const formatOptionLabel = ({label, projectsCount}) => {
        return (
            <div className="flex justify-between">
                <span>{label}</span>
                <span>{TB.pluralize("Project", projectsCount, true)}</span>
            </div>
        )
    }

    return (
        <>
            <div className="hidden md:flex flex-wrap gap-4 justify-center">
                {TB.map(tabs, (items, tab) => {
                    const isActive = TB.toLower(tab) === TB.toLower(activeTab);

                    return (
                        <button
                            key={tab}
                            disabled={isDisabled || items.length <= 0}
                            className={TB.mapClass('px-3 py-2 border', {
                                'border-secondary bg-secondary text-white': isActive,
                                'border-black': !isActive,
                                'opacity-50': isDisabled || items.length <= 0 && !isActive,
                            })}
                            style={buttonStyles}
                            onClick={() => !isActive && onChange(tab)}
                        >
                            {tab}&nbsp;<small>({items.length || 0})</small>
                        </button>
                    )
                })}
            </div>

            <div className="md:hidden m-auto px-4 max-w-lg w-full">
                <Select
                    defaultValue={options[0]}
                    menuPortalTarget={document.body}
                    isSearchable={false}
                    options={options}
                    isDisabled={isDisabled}
                    styles={customSelectStyles}
                    onChange={option => option.value !== activeTab && onChange(option.value)}
                    formatOptionLabel={formatOptionLabel}
                    isOptionDisabled={(option) => option.projectsCount === 0}
                />
            </div>
        </>
    )
}

const SimpleStatusTabs = ({ tabs, activeTab, onChange, buttonStyles, isDisabled }) => {
    const options = TB.map(tabs, (count, tab) => { return { label: tab, value: tab, projectsCount: count } })

    const formatOptionLabel = ({label, projectsCount}) => {
        return (
            <div className="flex justify-between">
                <span>{label}</span>
                <span>{TB.pluralize("Project", projectsCount, true)}</span>
            </div>
        )
    }

    return (
        <>
            <div className="hidden md:flex flex-wrap gap-4 justify-center">
                {TB.map(tabs, (count, tab) => {
                    const isActive = TB.toLower(tab) === TB.toLower(activeTab);

                    return (
                        <button
                            key={tab}
                            disabled={isDisabled || count <= 0}
                            className={TB.mapClass('px-3 py-2 border', {
                                'border-secondary bg-secondary text-white': isActive,
                                'border-black': !isActive,
                                'opacity-50': isDisabled || count <= 0 && !isActive,
                            })}
                            style={buttonStyles}
                            onClick={() => !isActive && onChange(tab)}
                        >
                            {tab}&nbsp;<small>({count || 0})</small>
                        </button>
                    )
                })}
            </div>

            <div className="md:hidden m-auto px-4 max-w-lg">
                <Select
                    defaultValue={options[0]}
                    menuPortalTarget={document.body}
                    isSearchable={false}
                    options={options}
                    isDisabled={isDisabled}
                    styles={customSelectStyles}
                    onChange={option => option.value !== activeTab && onChange(option.value)}
                    formatOptionLabel={formatOptionLabel}
                    isOptionDisabled={(option) => option.projectsCount === 0}
                />
            </div>
        </>
    )
}


export default StatusTabs;

export {
    SimpleStatusTabs
}

StatusTabs.propTypes = {
    tabs: PropTypes.object,
    activeTab: PropTypes.string,
    onChange: PropTypes.func,
    buttonStyles: PropTypes.object,
};

const customSelectStyles = {
    option: (provided, state) => {
        let bg = '';
        if (state.isDisabled) {
            bg = theme.colors.gray[200];
        } else if (state.isSelected) {
            bg = theme.colors.secondary.DEFAULT;
        } else if (state.isFocused) {
            bg = '#E7DFFA';
        }

        return {
            ...provided,
            color: state.isSelected ? 'white' : '',
            backgroundColor: bg,
            opacity: state.isDisabled ? 0.5 : 1,
        }
    },
    menuPortal: provided => ({ ...provided, zIndex: 1000 }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
}